// extracted by mini-css-extract-plugin
export default {"otherInfo":"pickup_otherInfo__iKM27","inputCode":"pickup_inputCode__PHAme","inputPass":"pickup_inputPass__28e+0"};